import type { EpisodeManifest } from "./stage-api";

/** Show only explicitly selected edition sources; never infer a CTA from a title. */
export function editionResourceLinks(sources: EpisodeManifest["sources"]) {
  const links: Array<{ label: string; url: string }> = [];
  for (const source of sources) {
    if (typeof source.actionLabel !== "string") continue;
    const label = source.actionLabel.trim();
    if (!label || label.length > 120 || /[\u0000-\u001f\u007f]/.test(label)) continue;
    try {
      const url = new URL(source.url);
      if (url.protocol !== "https:" || url.username || url.password || links.some(link => link.url === url.href)) continue;
      links.push({ label, url: url.href });
    } catch { /* Malformed optional links cannot break the player. */ }
    if (links.length === 3) break;
  }
  return links;
}
